import React from 'react';
interface ProductItem {
  item: string;
  description?: string;
  unit: number;
  unitPrice: number;
  discount?: number;
  amount: number;
}
interface PaxStatementProductsProps {
  items: ProductItem[];
  totals: {
    subtotal: number;
    totalDiscount: number;
    totalGST: number;
    grandTotal: number;
    currency: string;
  };
}
export function PaxStatementProducts({
  items,
  totals
}: PaxStatementProductsProps) {
  const formatCurrency = (amount: number) => {
    return `${totals.currency} ${amount.toFixed(2)}`;
  };
  const formatDiscount = (discount?: number) => {
    if (!discount || discount === 0) {
      return '—';
    }
    return `–${formatCurrency(Math.abs(discount))}`;
  };
  return <div className="mb-6" data-id="element-780">
      <h3 className="text-sm font-bold text-neutral-900 uppercase tracking-wide mb-4 pb-2 border-b-2 border-neutral-300" data-id="element-781">
        Product & Services
      </h3>

      {/* Table */}
      <div className="border border-neutral-200 rounded-lg overflow-hidden mb-4" data-id="element-782">
        <table className="w-full text-xs" data-id="element-783">
          <thead className="bg-neutral-50 border-b border-neutral-200" data-id="element-784">
            <tr data-id="element-785">
              <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-786">
                Item
              </th>
              <th className="text-center font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-787">
                Unit
              </th>
              <th className="text-right font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-788">
                Unit Price
              </th>
              <th className="text-right font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-789">
                Discount
              </th>
              <th className="text-right font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-790">
                Amount
              </th>
            </tr>
          </thead>
          <tbody data-id="element-791">
            {items.map((item, index) => <tr key={index} className="border-b border-neutral-200 last:border-b-0" data-id="element-792">
                <td className="px-3 py-2.5" data-id="element-793">
                  <p className="font-semibold text-neutral-900" data-id="element-794">{item.item}</p>
                  {item.description && <p className="text-neutral-600 text-xs mt-0.5" data-id="element-795">
                      {item.description}
                    </p>}
                </td>
                <td className="px-3 py-2.5 text-center text-neutral-900" data-id="element-796">
                  {item.unit}
                </td>
                <td className="px-3 py-2.5 text-right text-neutral-900 tabular-nums" data-id="element-797">
                  {formatCurrency(item.unitPrice)}
                </td>
                <td className="px-3 py-2.5 text-right text-green-600 tabular-nums" data-id="element-798">
                  {formatDiscount(item.discount)}
                </td>
                <td className="px-3 py-2.5 text-right font-semibold text-neutral-900 tabular-nums" data-id="element-799">
                  {formatCurrency(item.amount)}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      {/* Divider before totals */}
      <div className="h-px bg-neutral-200 mb-4" data-id="element-800" />

      {/* Totals */}
      <div className="flex justify-end" data-id="element-801">
        <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-5 min-w-[320px]" data-id="element-802">
          <div className="space-y-2.5" data-id="element-803">
            <div className="flex justify-between items-center" data-id="element-804">
              <span className="text-xs font-medium text-neutral-600" data-id="element-805">
                Subtotal:
              </span>
              <span className="text-xs text-neutral-900 tabular-nums" data-id="element-806">
                {formatCurrency(totals.subtotal)}
              </span>
            </div>
            <div className="flex justify-between items-center" data-id="element-807">
              <span className="text-xs font-medium text-neutral-600" data-id="element-808">
                Total Discount & Commission:
              </span>
              <span className="text-xs text-green-600 tabular-nums" data-id="element-809">
                –{formatCurrency(totals.totalDiscount)}
              </span>
            </div>
            <div className="flex justify-between items-center" data-id="element-810">
              <span className="text-xs font-medium text-neutral-600" data-id="element-811">
                Total GST:
              </span>
              <span className="text-xs text-neutral-900 tabular-nums" data-id="element-812">
                {formatCurrency(totals.totalGST)}
              </span>
            </div>
            <div className="h-px bg-neutral-300" data-id="element-813" />
            <div className="flex justify-between items-center bg-blue-50 border border-blue-200 -mx-5 px-5 py-2.5 rounded" data-id="element-814">
              <span className="text-sm font-bold text-neutral-900" data-id="element-815">
                Grand Total:
              </span>
              <span className="text-base font-bold text-blue-700 tabular-nums" data-id="element-816">
                {formatCurrency(totals.grandTotal)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}